import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { IdentityService } from 'main/services/identity.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class ExportNonProxiedOp extends BaseOperation {
  icon = 'far fa-download'
  showInOverflowMenu = true
  supportsDirs = true
  weight = 200

  constructor (
    translate: TranslateService,
    private identity: IdentityService,
    private panel: PanelService,
  ) {
    super()
    this.label = translate.instant('Export non-proxied file list')
  }

  isEnabledForDir () {
    return this.identity.hasPermission('media:roots:manage') && !this.panel.active
  }

  async runForDir (dir, context) {
    window.location.href = `/api/2/private/export/non-proxied/${context.root.id}/${dir.path}`
  }
}

MediaOperationsService.register(ExportNonProxiedOp)
